import * as _ from 'lodash';
import { FilterSet } from './filter-set';
import { LogicalOperator } from './logical-operator';
import { Filter } from './filter';
import { ComparisonOperator } from './comparison-operator';
import { Injectable } from '@angular/core';

export interface FieldOperatorConfig {
  [field: string]: ComparisonOperator;
}

@Injectable({ providedIn: 'root' })
export class FilterBuilder {

  constructor() { }

  public fromObject(valueObject: any,
    fieldOperatorConfig?: FieldOperatorConfig,
    operator: LogicalOperator = LogicalOperator.and,
    searchFields: string[] = [],
    searchInput: string = 'search'): FilterSet {

    fieldOperatorConfig = fieldOperatorConfig || {};

    const filterSet = <FilterSet> {
      operator: operator,
      filters: new Array<Filter>(),
      sets: []
    };

    for (const field of Object.keys(valueObject)) {
      if (valueObject[field]) {
        if (field === searchInput && searchFields && searchFields.length) {
          filterSet.sets.push(this.buildSearchFilterSet(valueObject[field], searchFields, fieldOperatorConfig));
        } else {
        filterSet.filters.push(<Filter> {
          field: field,
          value: valueObject[field],
          operator: fieldOperatorConfig[field] || ComparisonOperator.equals
        });
        }
      }
    }

    return filterSet;
  }

  buildSearchFilterSet(input: string, fields: string[], fieldOperatorConfig?: FieldOperatorConfig): FilterSet {

    const searchFilterSet = <FilterSet> {
      operator: LogicalOperator.and,
      filters: new Array<Filter>(),
      sets: []
    };

    if (!input || !fields || !fields.length) {
      return searchFilterSet;
    }

    const inputTokens = input.split(' ');
    _.each(inputTokens, (inputToken) => {
      inputToken = inputToken.trim();
      if (!(inputToken && inputToken.length)) {
        return;
      }

      const tokenFilter = <FilterSet>{
        operator: LogicalOperator.or,
        filters: []
      };
      searchFilterSet.sets.push(tokenFilter);

      _.each(fields, (field) => {
        tokenFilter.filters.push(<Filter> {
          field: field,
          value: inputToken,
          operator: fieldOperatorConfig[field] || ComparisonOperator.contains
        });
      });

    });

    return searchFilterSet;
  }

  public buildUriComponent(filterSet: FilterSet) {
    if (!filterSet) {
      return '';
    }

    return this.buildFilterSetString(filterSet);
  }

  private buildFilterString(filter: Filter): string {
    return `${filter.field}~${filter.operator}~${filter.value}`;
  }

  private buildFilterSetString(filterSet: FilterSet): string {
    const filterSections: string[] = [];

    if (filterSet.filters && filterSet.filters.length > 0) {
      const filters = filterSet.filters.map(this.buildFilterString, this);
      filterSections.push(filters.join(`~${filterSet.operator}~`));
    }

    const setString = this.buildFilterSetSetsString(filterSet);
    if (!!setString) {
      filterSections.push(setString);
    }

    return filterSections.join(`~${filterSet.operator}~`);
  }

  private buildFilterSetSetsString(filterSet: FilterSet): string {
    if (filterSet.sets && filterSet.sets.length > 0) {
      const filters = filterSet.sets.map(this.buildFilterSetString, this);

      return _.map(filters, (filter) => `(${filter})`).join(`~${filterSet.operator}~`);
    }
    return '';
  }
}
